import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("gavito-cookie-consent")) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (val) => {
    localStorage.setItem("gavito-cookie-consent", val);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[60] bg-white border border-gavito-navy/10 rounded-2xl shadow-xl p-6">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-gavito-green/15 flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5 text-gavito-green" />
        </div>
        <div>
          <p className="font-heading font-bold text-gavito-navy">Používáme cookies</p>
          <p className="text-sm text-gavito-navy/70 mt-1 leading-relaxed">
            Nezbytné cookies zajišťují správné fungování webu. S vaším souhlasem používáme i cookies pro analýzu návštěvnosti.
            Více v{" "}
            <Link to="/gdpr" className="text-gavito-green font-semibold hover:underline">zásadách ochrany údajů</Link>.
          </p>
          <div className="flex gap-2 mt-4">
            <button
              data-testid="cookie-accept"
              onClick={() => decide("all")}
              className="bg-gavito-navy text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-gavito-green transition-colors"
            >
              Přijmout vše
            </button>
            <button
              data-testid="cookie-necessary"
              onClick={() => decide("necessary")}
              className="border border-gavito-navy/20 text-gavito-navy text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-gavito-navy/5 transition-colors"
            >
              Jen nezbytné
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
